<template>
  <VcLabel v-if="label" :required="isRequired">
    {{ label }}
  </VcLabel>

  <Datepicker
    :disabled="isDisabled"
    :placeholder="label"
    :model-value="modelValue ? formattedValue : ''"
    :disabled-week-days="[0, 6]"
    :disabled-dates="disabledDates"
    :min-date="defaultDate"
    no-today
    :required="isRequired"
    model-type="dd-MM-yyyy"
    auto-apply
    format="dd-MM-yyyy"
    :enable-time-picker="false"
    @update:model-value="handleDate"
  />

  <div v-if="errorMessage" class="text-xs text-[color:var(--color-danger)]">
    {{ errorMessage }}
  </div>
</template>

<script setup lang="ts">
import Datepicker from "@vuepic/vue-datepicker";
import moment from "moment";
import { computed } from "vue";
import "@vuepic/vue-datepicker/dist/main.css";

const emit = defineEmits<{
  (e: "update:modelValue", value: Date | undefined): void;
  (e: "change", value: Date | undefined): void;
}>();

const props = defineProps({
  label: {
    type: String,
    default: undefined,
  },

  defaultDate: {
    type: Date,
    default: undefined,
  },

  disabledDates: {
    type: Array<string>,
    default: undefined,
  },

  isRequired: {
    type: Boolean,
    default: false,
  },

  isDisabled: {
    type: Boolean,
    default: false,
  },

  modelValue: {
    type: Date,
    default: undefined,
  },

  errorMessage: {
    type: String,
    default: undefined,
  },
});

const formattedValue = computed(() => moment(props.modelValue).format("DD-MM-YYYY"));

function handleDate(selectedDate: string) {
  const dateValue = selectedDate ? moment(selectedDate, "DD/MM/YYYY").toDate() : undefined;

  emit("update:modelValue", dateValue);
}

const disabledDates = computed(() => {
  if (props.disabledDates && props.disabledDates.filter(x => x !== null).length > 0) {
    return props.disabledDates.map((dateStr) => {
      const [year, month, day] = dateStr.split("-").map(Number);
      return new Date(year, month - 1, day);
    });
  }
  return [];
});
</script>

<style>
.dp__cell_inner.dp__cell_offset.dp__pointer.dp--future.dp__date_hover {
  color: #000 !important;
}
</style>
